import React, {useEffect, useRef, useState} from "react";
import { getCountriesLists } from "../../service";
import {CountriesProps} from "../../pages/types";
import Pagination from "../pagination";
import usePagination from "../../routers/usePagination";
const classnames = require('classnames')


type Props = {
    onChange:(code:CountriesProps) => void,
    propName?: keyof CountriesProps,
    label?:string,
    icon?:string
}

const CountriesPicker:React.FC<Props> = (props) => {

    const [status,setStatus] = useState<boolean>(false);
    const [lists,setLists] = useState<Array<CountriesProps>>([]);
    const [pageNum,setPage] = useState<number>(1);
    const [active,setActive] = useState<number>(0)
    const { pageRef,noMore } = usePagination()
    const propName = props.propName || 'areaCode'

    useEffect(() => {
        getCountriesLists({
            pageNum
        }).then(res => {
            if(res.code === 1){
                const lists = res.data.list
                if((lists as Array<CountriesProps>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }

            }
        })
        console.log(pageNum)
    },[pageNum])

    const confirmHandle = () => {
        setStatus(false)
        if(lists[active]){
            props.onChange(lists[active])
        }
    }

    return <div className="countries-picker">
        <div className="selector" onClick={() => setStatus(true)}>{ props.label } { lists[active] && lists[active][propName] } <span className="iconfont" dangerouslySetInnerHTML={{ __html:props.icon || '&#xe608;' }}/> </div>

        {
            status && <div className="cover" onClick={() => setStatus(false)}>
                <div className="box" onClick={event => event.stopPropagation()}>
                    <div className="title">选择地区</div>
                    <div className="lists">
                        {
                            lists.map((item,index) => {
                                return <div className={classnames("item",{"active": active === index })} onClick={() => setActive(index)} key={index}>
                                    <div> <span>+ { item.areaCode }</span> <p>{ item.zhName } { item.enName }</p></div>
                                </div>
                            })
                        }
                        <Pagination ref={pageRef} length={lists.length}  onChange={ (n) => setPage(n) }/>
                    </div>
                    <div className="btns">
                        <div className="btn" onClick={ confirmHandle }>确定</div>
                    </div>
                </div>
            </div>
        }
    </div>
}

export default CountriesPicker
